import VendorReportContainer from "./VendorReportContainer";

export default VendorReportContainer;